"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../Button"));
var _Button2 = require("../Button/Button");
var _MobileGallery = _interopRequireDefault(require("../MobileGallery"));
var _userflow = require("../../utils/userflow");
var _excluded = ["description", "gallery", "isMobile", "onExpand", "title"];
var CrownIcon = function CrownIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    stroke: "#000",
    fill: "#F8E71C",
    fillRule: "evenodd",
    d: "M1.823 12A45.053 45.053 0 0 0 0 2.584l4.758 3.554L9 0l4.242 6.138L18 2.584A44.99 44.99 0 0 0 16.177 12c-4.324-.007-10.03-.007-14.354 0z",
    clipRule: "evenodd"
  }));
};
CrownIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 12"
};
var StyledCounter = _MobileGallery["default"].StyledCounter;
var HotelExperienceCard = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var description = _ref.description,
    gallery = _ref.gallery,
    isMobile = _ref.isMobile,
    onExpand = _ref.onExpand,
    title = _ref.title,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledHotelExperienceCard, (0, _extends2["default"])({
    isMobile: isMobile
  }, props), !(0, _isEmpty2["default"])(gallery) && /*#__PURE__*/_react["default"].createElement(StyledGalleryContainer, null, /*#__PURE__*/_react["default"].createElement(_MobileGallery["default"], {
    controls: !isMobile,
    counter: true,
    height: isMobile ? 260 : 300,
    images: gallery,
    width: isMobile ? 210 : 420
  })), /*#__PURE__*/_react["default"].createElement(StyledTitle, null, title), /*#__PURE__*/_react["default"].createElement(CrownIcon, {
    width: isMobile ? 17 : 18,
    height: isMobile ? 12 : 13
  }), /*#__PURE__*/_react["default"].createElement(StyledDescription, null, description), /*#__PURE__*/_react["default"].createElement(StyledExpandButton, {
    size: isMobile ? _Button2.Sizes.TINY : _Button2.Sizes.NORMAL,
    onClick: onExpand
  }, "\u041F\u043E\u0447\u0438\u0442\u0430\u0442\u044C \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E"));
});
HotelExperienceCard.propTypes = {
  className: _propTypes["default"].string,
  description: _propTypes["default"].string,
  gallery: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    images: _propTypes["default"].shape((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _userflow.IMAGES_SIZE.SMALL, _propTypes["default"].string), _userflow.IMAGES_SIZE.FULL, _propTypes["default"].string), _userflow.IMAGES_SIZE.BIG, _propTypes["default"].string.isRequired), _userflow.IMAGES_SIZE.BIG_X2, _propTypes["default"].string)).isRequired,
    special: _propTypes["default"].shape({
      id: _propTypes["default"].number,
      content: _propTypes["default"].string,
      title: _propTypes["default"].string
    }).isRequired
  })),
  isMobile: _propTypes["default"].bool,
  onExpand: _propTypes["default"].func,
  title: _propTypes["default"].string.isRequired
};
HotelExperienceCard.defaultProps = {
  className: '',
  description: null,
  gallery: [],
  isMobile: false,
  onExpand: Function.prototype
};
var StyledGalleryContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelExperienceCard__StyledGalleryContainer",
  componentId: "sc-1n3vg0e-0"
})(["width:100%;border-radius:6px;margin-bottom:12px;overflow:hidden;"]);
var StyledTitle = _styledComponents["default"].span.withConfig({
  displayName: "HotelExperienceCard__StyledTitle",
  componentId: "sc-1n3vg0e-1"
})(["margin-right:7px;"]);
var StyledDescription = _styledComponents["default"].div.withConfig({
  displayName: "HotelExperienceCard__StyledDescription",
  componentId: "sc-1n3vg0e-2"
})(["margin-bottom:16px;margin-top:7px;text-align:left;white-space:normal;"]);
var StyledExpandButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "HotelExperienceCard__StyledExpandButton",
  componentId: "sc-1n3vg0e-3"
})(["max-width:169px;padding:0 17px;width:auto;margin-bottom:2px;"]);
var StyledHotelExperienceCard = _styledComponents["default"].div.withConfig({
  displayName: "HotelExperienceCard__StyledHotelExperienceCard",
  componentId: "sc-1n3vg0e-4"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme,
    isMobile = _ref2.isMobile;
  return "\n    width: ".concat(isMobile ? 210 : 420, "px;\n    animation: fade 400ms ease;\n\n    ").concat(StyledTitle, " {\n      ").concat(theme.typography[isMobile ? 'headline4' : 'headline3'], "\n      color: ").concat(theme.colors.blackBase, ";\n    }\n\n    ").concat(StyledDescription, " {\n      ").concat(theme.typography[isMobile ? 'text3' : 'text1'], "\n      color: ").concat(theme.colors.greyLight, ";\n    }\n\n    ").concat(StyledExpandButton, " {\n      ").concat(theme.typography[isMobile ? 'text3' : 'text1'], "\n    }\n\n    ").concat(StyledCounter, " {\n      bottom: ").concat(isMobile ? 9 : 16, "px;\n      right: ").concat(isMobile ? 8 : 12, "px;\n    }\n\n    &[data-hidden=\"true\"] {\n      display: none;\n    }\n\n    @keyframes fade {\n      from {opacity: 0;}\n    }\n  ");
});
var _default = exports["default"] = HotelExperienceCard;